import React, { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { CalendarClock } from "lucide-react";
import { api } from "@/lib/api";

export default function ContractAlertsWidget({ nav }) {
  const [alerts, setAlerts] = useState([]);
  useEffect(() => {
    api.get("/contract-alerts/preview")
      .then((r) => setAlerts(r.data?.contracten || []))
      .catch(() => {});
  }, []);
  if (alerts.length === 0) return null;
  return (
    <Card className="p-4 border-amber-300 bg-amber-50" data-testid="dashboard-contract-widget">
      <div className="flex items-center gap-2 text-sm font-semibold text-amber-800">
        <CalendarClock className="h-4 w-4" /> Aflopende contracten ({alerts.length})
      </div>
      <div className="flex flex-wrap gap-2 mt-2">
        {alerts.map((a) => (
          <button key={a.employee_id} onClick={() => nav(`/medewerkers/${a.employee_id}`)}
            className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-white border border-amber-300 text-xs hover:bg-amber-100"
            data-testid={`dashboard-contract-chip-${a.employee_id}`}>
            <span className="font-medium">{a.naam}</span>
            <span className="text-slate-500">{a.contract_eind}</span>
            <span className={`px-1.5 py-0.5 rounded-full text-[10px] font-bold text-white ${a.dagen_tot_einde <= 14 ? "bg-rose-500" : "bg-amber-500"}`}>
              {a.dagen_tot_einde} dgn
            </span>
          </button>
        ))}
      </div>
    </Card>
  );
}
